import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Spinner, Collapse } from 'reactstrap';
import axios from 'axios';
import config from '../../config.js';
import { store } from '../../store/index.js';
import { toggleSidebar } from '../../actions';
import ScanAndPayOpsFlow from './ScanAndPayOpsFlow';
import ScanAndPayUserFlowModal from './ScanAndPayUserFlowModal';
import { getBlobUrlAndContentType } from '../../utils/getBlobUrlAndContentType.js';
import { Link } from 'react-router-dom';
import NavBar from '../layout/NavBar';
import { FaPhone } from 'react-icons/fa';
import { toast } from 'react-toastify';
import ModalConfirm from '../common/ModalConfirm';
import { clickToCallForOrder } from '../../services/api/get-labs-orders';
import { getOpsCallReasons } from '../pharmacy-orders/UploadRxComponents/Services';

const CSV_PAGE_SIZE = 10000;

const apiRequest = async (url, method = 'GET', data = null) => {
    const headers = {
        'Content-Type': 'application/json',
    };
    const state = store.getState();
    if (state.user.token) {
        headers.Authorization = state.user.token;
    }

    try {
        const response = await axios({
            url,
            method,
            data,
            headers,
        });
        return response.data;
    } catch (err) {
        const errorMessage = err.response && err.response.data && err.response.data.message || err.message;
        throw new Error(errorMessage);
    }
};

// API calls using the helper function
const getScanAndPayCartDetailByCartId = async (cartId) => {
    return await apiRequest(`${config.pharmacyService}/scan-and-pay/fetch-cart-detail?cartId=${cartId}&isSecureDocumentUrl=1`);
};

const getScanAndPayCaseListSummary = async ({
    digitisationRequestId = null,
    phone = null,
    sponsorName = null,
    enabledByOps = null,
    orderId = null,
    fromDate = null,
    toDate = null,
    callStatus = null,
} = {}) => {
    let url = `${config.pharmacyService}/scan-and-pay/fetch-case-list-summary?`;

    if (Number(digitisationRequestId))
        url += `&digitisationRequestId=${digitisationRequestId}`;

    if (Number(phone))
        url += `&phone=${phone}`;

    if (sponsorName)
        url += `&sponsorName=${encodeURIComponent(sponsorName)}`;

    if (enabledByOps !== null)
        url += `&enabledByOps=${enabledByOps}`;

    if (Number(orderId))
        url += `&orderId=${orderId}`;

    if (fromDate)
        url += `&fromDate=${encodeURIComponent(fromDate)}`;

    if (toDate)
        url += `&toDate=${encodeURIComponent(toDate)}`;

    if (callStatus)
        url += `&callStatus=${encodeURIComponent(callStatus)}`;

    return await apiRequest(url);
};

const getCaseList = async ({
    offset = 0,
    limit = null,
    caseType = null,
    digitisationRequestId = null,
    phone = null,
    sponsorName = null,
    enabledByOps = null,
    orderId = null,
    fromDate = null,
    toDate = null,
    callStatus = null,
}) => {
    let url = `${config.pharmacyService}/scan-and-pay/fetch-case-list?offset=${offset}`;

    if (Number(limit))
        url += `&limit=${limit}`;

    if (Number(digitisationRequestId))
        url += `&digitisationRequestId=${digitisationRequestId}`;

    if (Number(phone))
        url += `&phone=${phone}`;

    if (caseType)
        url += `&caseType=${caseType}`;

    if (callStatus)
        url += `&callStatus=${encodeURIComponent(callStatus)}`;

    if (sponsorName)
        url += `&sponsorName=${encodeURIComponent(sponsorName)}`;

    if (enabledByOps !== null && enabledByOps !== '')
        url += `&enabledByOps=${enabledByOps}`;

    if (Number(orderId))
        url += `&orderId=${orderId}`;

    if (fromDate)
        url += `&fromDate=${encodeURIComponent(fromDate)}`;

    if (toDate)
        url += `&toDate=${encodeURIComponent(toDate)}`;

    return await apiRequest(url);
};

const cellStyle = {
    padding: '10px 12px',
    textAlign: 'left',
    borderRight: '1px solid #f1f5f9',
    whiteSpace: 'nowrap',
    color: '#334155',
    fontSize: '13px',
};

const BRAND = '#6C5DD3';

const C = {
    blue:   '#0EA5E9',
    green:  '#22C55E',
    red:    '#EF4444',
    amber:  '#F59E0B',
    slate:  '#64748B',
    border: '#E2E8F0',
    dark:   '#0f172a',
    violet: '#A78BFA',
    cyan:   '#22D3EE',
};

const tableHeaderCellStyle = {
    background: BRAND,
    color: '#fff',
    padding: '10px 12px',
    fontWeight: '600',
    whiteSpace: 'nowrap',
    borderRight: '1px solid rgba(255,255,255,0.15)',
    textAlign: 'left',
};

const sectionCardStyle = {
    border: '1px solid #e0daf8',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(108,93,211,0.08)',
    padding: '10px',
};

const headerCardStyle = {
    backgroundColor: '#FFFFFF',
    border: '1px solid #E2E8F0',
    borderRadius: '12px',
    boxShadow: '0 4px 14px rgba(15,23,42,0.06)',
    padding: '16px 20px',
};

const primaryButtonStyle = {
    padding: '6px 14px',
    backgroundColor: BRAND,
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '13px',
};

const activeRowStyle = {
    backgroundColor: '#f4f3ff',
    borderBottom: '1px solid #e0daf8',
};


const getCallList = async (cartId) => {
    const url = `${config.pharmacyService}/scan-and-pay/fetch-call-list?cartId=${cartId}`;
    try {
        const response = await apiRequest(url);
        return response;
    } catch (err) {
        throw new Error(err.message);
    }
};

const getOrderList = async (cartId) => {
    const url = `${config.pharmacyService}/scan-and-pay/fetch-order-list?cartId=${cartId}`;
    try {
        const response = await apiRequest(url);
        return response;
    } catch (err) {
        throw new Error(err.message);
    }
};


const getUpiScanList = async (cartId) => {
    const url = `${config.pharmacyService}/scan-and-pay/fetch-upi-scan-list?cartId=${cartId}`;
    try {
        const response = await apiRequest(url);
        return response;
    } catch (err) {
        throw new Error(err.message);
    }
};


const getCaseComments = async (cartId) => {
    const url = `${config.pharmacyService}/scan-and-pay/fetch-case-comments?cartId=${cartId}`;
    try {
        const response = await apiRequest(url);
        return response;
    } catch (err) {
        throw new Error(err.message);
    }
};

const addCaseComment = async (cartId, comment) => {
    return await apiRequest(`${config.pharmacyService}/scan-and-pay/add-case-comment`, 'POST', { cartId, comment });
};


const updateCartApprovedAmount = async (cartId, approvedAmount) => {
    return await apiRequest(`${config.pharmacyService}/scan-and-pay/update-cart-approved-amount`, 'POST', { cartId, approvedAmount });
};


const enableScanAndPay = async (digitisationRequestId, isForOps) => {
    return await apiRequest(`${config.pharmacyService}/scan-and-pay/enable-scan-and-pay`, 'POST', { digitisationRequestId, isForOps });
};


class PharmacyScanAndPayHome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cartId: '',
            cartDetails: {
                items: { covered: [], uncovered: [] },
                totalAmount: null,
                requestedAmount: null,
                approvedAmount: null,
                prescriptionUrl: '',
                cartId: null,
            },
            approvedAmount: null,
            error: '',
            loading: false,
            updating: false,
            caseList: [],
            caseListSummary: {},
            caseListLoading: true,
            caseListSummaryLoading: true,
            callListLoading: false,
            orderListLoading: false,
            upiScanListLoading: false,
            caseCommentsLoading: false,
            offset: 0, // Initial offset for pagination
            limit: 10, // Number of items per page
            caseType: null,
            filterPhone: '',
            filterDigitisationRequestId: '',
            filterSponsorName: '',
            filterEnabledByOps: '',
            filterCallStatus: '',
            filterOrderId: '',
            filterFromDate: '',
            filterToDate: '',
            enableDigitisationRequestId: '',
            isForOps: false,
            callList: [],
            orderList: [],
            upiScanList: [],
            caseComments: [],
            newCaseComment: '',
            postingComment: false,
            isCommentsOpen: true,
            activeCartId: null,
            selectedRowIndex: null,
            isFlowChartOpen: false,
            userFlowModal: null,
            userFlowDigitisationId: '',
            callReasons: [],
            callProcessing: false,
            callConfirmModal: {
                isOpen: false,
                message: 'Initiate a call between you and the user?',
                isOpsCallForPharmacy: false,
                opsCallReasons: [],
                onConfirm: () => {},
                onClose: () => {},
            },
        };
    }

    fetchCartDetails = async (cartId = null) => {
        if (!cartId) {
            this.setState({
                cartId: null,
                cartDetails: null,
                approvedAmount: null,
                callList: [],
                orderList: [],
                upiScanList: [],
                caseComments: [],
                newCaseComment: '',
                activeCartId: null,
                loading: false
            });
            return;
        }

        this.setState({ loading: true, error: '' });

        try {
            const data = await getScanAndPayCartDetailByCartId(cartId);

            if (data.success) {
                if (data.cart && data.cart.prescriptionUrl) {
                    const state = store.getState();
                    if (state.user.token) {
                        data.cart.prescriptionUrl = await getBlobUrlAndContentType({
                            fileUrl: data.cart.prescriptionUrl,
                            headers: {Authorization: state.user.token}
                        }).then(res => res.blobUrl);
                    }
                }
                this.setState({
                    cartId,
                    cartDetails: data.cart,
                    approvedAmount: null,
                    error: '',
                    loading: false
                });
            } else {
                this.setState({
                    cartId,
                    error: data.message,
                    approvedAmount: null,
                    loading: false
                });
            }
        } catch (err) {
            this.setState({
                cartId,
                error: err.message,
                approvedAmount: null,
                loading: false
            });
        }
    };

    getCaseListSumary = async () => {
        this.setState({ caseListSummaryLoading: true });

        try {
            const data = await getScanAndPayCaseListSummary({
                digitisationRequestId: this.state.filterDigitisationRequestId,
                phone: this.state.filterPhone,
                sponsorName: this.state.filterSponsorName,
                enabledByOps: this.state.filterEnabledByOps === '1' ? 1 : this.state.filterEnabledByOps === '0' ? 0 : null,
                orderId: this.state.filterOrderId,
                fromDate: this.state.filterFromDate,
                toDate: this.state.filterToDate,
                callStatus: this.state.filterCallStatus || null
            });
            this.setState({ caseListSummary: data.caseListSummary });
        } catch (err) {
            this.setState({ error: err.message });
        } finally {
            this.setState({ caseListSummaryLoading: false });
        }
    };

    getCaseList = async () => {
        this.setState({ caseListLoading: true, selectedRowIndex: null, error: '' });
        this.fetchCartDetails();
        const {
            offset,
            caseType,
            filterDigitisationRequestId,
            filterPhone,
            filterSponsorName,
            filterEnabledByOps,
            filterOrderId,
            filterFromDate,
            filterToDate,
            filterCallStatus,
        } = this.state;

        if (filterFromDate && filterToDate && filterToDate < filterFromDate) {
            this.setState({
                caseList: [],
                caseListLoading: false,
                error: 'Invalid Date Range: "To" date cannot be earlier than "From" date.'
            });
            return;
        }

        try {
            const data = await getCaseList({
                offset,
                caseType,
                digitisationRequestId: filterDigitisationRequestId,
                phone: filterPhone,
                sponsorName: filterSponsorName,
                enabledByOps: filterEnabledByOps,
                orderId: filterOrderId,
                fromDate: filterFromDate,
                toDate: filterToDate,
                callStatus: filterCallStatus || null,
            });

            this.setState({ caseList: data.caseList });
        } catch (err) {
            this.setState({ error: err.message });
        } finally {
            this.setState({ caseListLoading: false });
        }
    };

    getCallList = async (cartId = null) => {
        const id = cartId || this.state.cartId;
        this.setState({ callListLoading: true });
        try {
            if (Number(id)) {
                const data = await getCallList(id);
                this.setState({ callList: data.callList });
            } else {
                this.setState({ error: 'Choose Cart Id First' });
            }
        } catch (err) {
            this.setState({ error: err.message });
        } finally {
            this.setState({ callListLoading: false });
        }
    };

    getOrderList = async (cartId = null) => {
        const id = cartId || this.state.cartId;
        this.setState({ orderListLoading: true });
        try {
            if (Number(id)) {
                const data = await getOrderList(id);
                let finalOrderList = data.orderList || [];
                const searchedOrderId = this.state.filterOrderId;
                if (searchedOrderId) {
                    finalOrderList = finalOrderList.sort((a, b) => {
                        if (String(a.orderId) === String(searchedOrderId)) return -1;
                        if (String(b.orderId) === String(searchedOrderId)) return 1;
                        return 0;
                    });
                }
                this.setState({ orderList: finalOrderList });
            } else {
                this.setState({ error: 'Choose Cart Id First' });
            }
        } catch (err) {
            this.setState({ error: err.message });
        } finally {
            this.setState({ orderListLoading: false });
        }
    };

    getUpiScanList = async (cartId = null) => {
        const id = cartId || this.state.cartId;
        this.setState({ upiScanListLoading: true });
        try {
            if (Number(id)) {
                const data = await getUpiScanList(id);
                this.setState({ upiScanList: data.upiScanList });
            } else {
                this.setState({ error: 'Choose Cart Id First' });
            }
        } catch (err) {
            this.setState({ error: err.message });
        } finally {
            this.setState({ upiScanListLoading: false });
        }
    };

    getCaseComments = async (cartId = null) => {
        const id = cartId || this.state.activeCartId;
        const isStillActive = () => String(this.state.activeCartId) === String(id);
        this.setState({ caseCommentsLoading: true });
        try {
            if (Number(id)) {
                const data = await getCaseComments(id);
                if (isStillActive()) {
                    this.setState({ caseComments: data.comments || [] });
                }
            } else {
                this.setState({ error: 'Choose Cart Id First' });
            }
        } catch (err) {
            if (isStillActive()) {
                this.setState({ error: err.message });
            }
        } finally {
            if (isStillActive()) {
                this.setState({ caseCommentsLoading: false });
            }
        }
    };

    postCaseComment = async () => {
        const { activeCartId, newCaseComment } = this.state;

        if (!Number(activeCartId)) {
            this.setState({ error: 'Choose Cart Id First' });
            return;
        }
        if (!newCaseComment || !newCaseComment.trim()) {
            return;
        }

        this.setState({ postingComment: true, error: '' });

        try {
            const response = await addCaseComment(activeCartId, newCaseComment.trim());
            if (response.success) {
                this.setState({ newCaseComment: '' });
                await this.getCaseComments(activeCartId);
            } else {
                this.setState({ error: response.message });
            }
        } catch (err) {
            this.setState({ error: err.message });
        } finally {
            this.setState({ postingComment: false });
        }
    };


    handlePrevPage = () => {
        this.setState((prevState) => {
            const newOffset = Math.max(prevState.offset - 1, 0); // Ensure offset doesn't go below 0
            return { offset: newOffset };
        }, () => {
            this.getCaseList();
        });
    };

    handleNextPage = () => {
        this.setState((prevState) => {
            const newOffset = prevState.offset + 1;
            return { offset: newOffset, };
        }, () => {
            this.getCaseList();
        });
    };

    // Handle input change for filters
    handleFilterChange = (filterType, value) => {
        this.setState({ [filterType]: value });
    };

    handleFilterDigitisationRequestIdChange = (event) => {
        this.setState({ filterDigitisationRequestId: event.target.value });
    };

    handleFilterPhoneChange = (event) => {
        this.setState({ filterPhone: event.target.value });
    };

    // Handle input change for cartId
    handleCartIdChange = (event) => {
        const cartId = event.target.value;
        this.setState({ cartId: cartId });
    };

    toggleSteps = () => this.setState({ isFlowChartOpen: !this.state.isFlowChartOpen });

    toggleComments = () => this.setState({ isCommentsOpen: !this.state.isCommentsOpen });

    openUserFlowModal = () => {
        const { userFlowDigitisationId } = this.state;
        if (!userFlowDigitisationId) return;
        this.setState({
            userFlowModal: {
                digitisationRequestId: userFlowDigitisationId,
            },
        });
    };

    // Handle input change for digitisationRequestId
    handleEnableDigitisationRequestIdChange = (event) => {
        this.setState({ enableDigitisationRequestId: event.target.value });
    };

    // Handle submit for fetching cart details
    handleCartIdSubmit = () => {
        const { cartId } = this.state;
        if (cartId) {
            this.fetchCartDetails(cartId);
        }
    };

    handleEnableScanAndPay = async () => {
        const { enableDigitisationRequestId } = this.state;

        if (!enableDigitisationRequestId) {
            this.setState({ error: "Please enter a valid digitisationRequestId." });
            return;
        }

        this.setState({ updating: true, error: '' });

        try {
            const response = await enableScanAndPay(this.state.enableDigitisationRequestId, this.state.isForOps);
            if (response.success) {
                this.setState({ updating: false });
            } else {
                this.setState({ error: response.message, updating: false });
            }
            this.setState({ scanAndPayEnabledUpdatedMessage: `Attempt ${response.isUpdated ? 'Success' : 'Failed'} For Digitisation Request Id: ${this.state.enableDigitisationRequestId}` });
        } catch (err) {
            this.setState({ error: err.message, updating: false });
        }
    }

    handleUpdateApprovedAmount = async () => {
        const { approvedAmount } = this.state;

        if (!approvedAmount || approvedAmount <= 0) {
            this.setState({ error: "Please enter a valid approved amount." });
            return;
        }

        this.setState({ updating: true, error: '' });

        try {
            const response = await updateCartApprovedAmount(this.state.cartId, approvedAmount);
            if (response.success) {
                // Fetch the updated cart details
                await this.fetchCartDetails(this.state.cartId);
                this.setState({ updating: false });
            } else {
                this.setState({ error: response.message, updating: false });
            }
        } catch (err) {
            this.setState({ error: err.message, updating: false });
        }
        this.setState({ approvedAmount: null });
    };


    downloadCsv = async () => {
        const { caseType, filterDigitisationRequestId, filterPhone, filterSponsorName, filterEnabledByOps, filterCallStatus } = this.state;
        this.setState({ csvDownloading: true, error: null });

        try {
            const allRows = [];
            let pageNumber = 0;
            let hasMore = true;

            while (hasMore) {
                const data = await getCaseList({
                    offset: pageNumber,
                    limit: CSV_PAGE_SIZE,
                    caseType,
                    digitisationRequestId: filterDigitisationRequestId,
                    phone: filterPhone,
                    sponsorName: filterSponsorName,
                    enabledByOps: filterEnabledByOps,
                    callStatus: filterCallStatus || null,
                });

                const page = Array.isArray(data?.caseList) ? data.caseList : [];
                allRows.push(...page);

                hasMore = Boolean(data?.pagination?.hasMore);
                pageNumber += 1;
            }

            const headers = [
                'Cart ID', 'Digitisation ID', 'Sponsor Name', 'Enabled By Ops Email', 'Enabled At', 'User Name', 'User Phone',
                'VIP User', 'Call Requested', 'Call Status', 'Payout Attempted', 'Payout Closed',
                'Invoice Uploaded', 'Reimbursement ID', 'Invoice Inspected',
                'Invoice Approved', 'Invoice Rejected',
                'Payout Amount', 'Invoice Approved Amount', 'Outstanding Amount', 'Invoice Closed',
            ];
            const rows = allRows.map((c) => [
                c.cartId ?? '',
                c.digitisationRequestId ?? '',
                c.sponsorName ?? '',
                c.enabledByOpsUserEmail ?? '',
                c.enabledAt ?? '',
                c.userName ?? '',
                c.userPhone ?? '',
                c.isVipUser ? 'Yes' : 'No',
                c.isCallRequested ? 'Yes' : 'No',
                c.callStatus ?? '',
                c.isPayoutAttempted ? 'Yes' : 'No',
                c.isPayoutClosed ? 'Yes' : 'No',
                c.isInvoiceUploaded ? 'Yes' : 'No',
                c.reimbursementRequestId ?? '',
                c.isInvoiceInspected ? 'Yes' : 'No',
                c.isInvoiceApproved ? 'Yes' : 'No',
                c.isInvoiceRejected ? 'Yes' : 'No',
                c.payoutAmount ?? '',
                c.invoiceApprovedAmount ?? '',
                c.outStandingAmount ?? '',
                c.isInvoiceClosed ? 'Yes' : 'No',
            ]);
            const csvContent = [headers, ...rows]
                .map((row) => row.map((val) => `"${String(val).replace(/"/g, '""')}"`).join(','))
                .join('\n');

            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');

            link.href = url;
            link.download = `scan-and-pay-cases-${new Date().toISOString().slice(0, 10)}.csv`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setTimeout(() => URL.revokeObjectURL(url), 1000);
        } catch (err) {
            this.setState({ error: err?.message || 'Failed to download CSV' });
        } finally {
            this.setState({ csvDownloading: false });
        }
    };

    componentDidMount() {
        this.props.closeSidebar();
        this.getCaseListSumary();
        this.getCaseList();
        this.fetchCallReasons();
    }

    fetchCallReasons = async () => {
        try {
            const callReasons = await getOpsCallReasons();
            this.setState({ callReasons });
        } catch (error) {
            console.error('Error fetching call reasons:', error);
        }
    };

    initiateCall = (orderId, phone, reasonForCalling) => {
        if (this.state.callProcessing) {
            return;
        }
        this.setState({ callProcessing: true });

        clickToCallForOrder(orderId, phone, 'pharmacy-order', reasonForCalling)
            .then((response) => {
                this.setState({ callProcessing: false });
                if (response.body.message === 'success') {
                    toast.success('Call initiated');
                } else {
                    toast.error('Unable to initiate call');
                }
            })
            .catch((err) => {
                this.setState({ callProcessing: false });
                console.error('Unable to initiate call', err);
                toast.error(`Unable to initiate call -  ${err.response && err.response.data && err.response.data.errorMessage || err.message}`);
                return Promise.resolve();
            });
    };

    openCallConfirmModal = (orderId, phone) => {
        this.setState({
            callConfirmModal: {
                isOpen: true,
                message: 'Initiate a call between you and the user?',
                isOpsCallForPharmacy: true,
                opsCallReasons: this.state.callReasons,
                onConfirm: (selectedCallReason) => {
                    this.initiateCall(orderId, phone, selectedCallReason);
                    return Promise.resolve();
                },
                onClose: () => {
                    this.setState({
                        callConfirmModal: {
                            isOpen: false,
                            onConfirm: () => {},
                            onClose: () => {},
                        },
                    });
                },
            },
        });
    };
    fetchFilteredData = () => {
        this.getCaseListSumary();
        this.getCaseList();
    };

    render() {
        const {
            cartId,
            cartDetails,
            error,
            loading,
            updating,
            caseList,
            selectedRowIndex,
            caseListSummary,
            caseListLoading,
            caseListSummaryLoading,
            orderListLoading,
            callListLoading,
            upiScanListLoading,
            offset,
            filterPhone,
            filterDigitisationRequestId,
            orderList,
            callList,
            upiScanList,
            caseComments,
            caseCommentsLoading,
            newCaseComment,
            postingComment,
            isCommentsOpen,
            enableDigitisationRequestId,
            scanAndPayEnabledUpdatedMessage,
            userFlowDigitisationId,
            csvDownloading,
            callConfirmModal,
        } = this.state;

        let totalCount = 0;
        if (caseListSummary) {
            if (this.state.caseType === null) totalCount = caseListSummary.totalCaseCount;
            else if (this.state.caseType === 'completed') totalCount = caseListSummary.completedCaseCount;
            else if (this.state.caseType === 'store-payout-stuck') totalCount = caseListSummary.storePaymentStuckCount;
            else if (this.state.caseType === 'invoice-not-uploaded') totalCount = caseListSummary.invoiceNotUploadedCount;
            else if (this.state.caseType === 'invoice-not-inspected') totalCount = caseListSummary.invoiceNotInspectedCount;
            else if (this.state.caseType === 'invoice-not-closed') totalCount = caseListSummary.invoiceNotClosed;
        }
        const pageSize = 10;
        const totalPages = Math.ceil((Number(totalCount) || 0) / pageSize) || 1;

        const boolIcon = (val) => val
            ? <span style={{ color: C.green, fontSize: '15px', fontWeight: '700' }}>✓</span>
            : <span style={{ color: '#94a3b8', fontSize: '15px', fontWeight: '700' }}>—</span>;

        const statusBadge = (status) => {
            if (!status) return <span style={{ color: '#94a3b8' }}>—</span>;
            const s = String(status).toLowerCase();
            let bg, color, dot;
            if (s.includes('not_triggered') || s.includes('not triggered')) {
                bg = '#ede9fe'; color = '#5b21b6'; dot = C.violet;
            } else if (s.includes('success') || s.includes('completed') || s.includes('done') || s.includes('answered')) {
                bg = '#dcfce7'; color = '#15803d'; dot = C.green;
            } else if (s.includes('fail') || s.includes('error') || s.includes('reject') || s.includes('missed') || s.includes('busy')) {
                bg = '#fee2e2'; color = '#b91c1c'; dot = C.red;
            } else if (s.includes('pending') || s.includes('process') || s.includes('initiated')) {
                bg = '#fef3c7'; color = '#92400e'; dot = C.amber;
            } else {
                bg = '#f1f5f9'; color = '#475569'; dot = C.slate;
            }
            return (
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', background: bg, color, padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: '600', whiteSpace: 'nowrap' }}>
                    <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: dot, display: 'inline-block' }} />
                    {status}
                </span>
            );
        };

        const rowStyle = (index) => ({
            backgroundColor: index % 2 === 0 ? '#fff' : '#f8fafc',
            borderBottom: `1px solid ${C.border}`,
        });

        const realCommentCount = caseComments.filter((comment) => !comment.isSystem).length;

        return (
            <div className="container-fluid px-0" style={{ paddingTop: '60px' }}>
            <NavBar />
            <section className="sp-root" style={{ width: '100%', padding: '16px', paddingTop: '0px', boxSizing: 'border-box', fontWeight: 600 }}>
                <style>{`
                    .sp-scroll::-webkit-scrollbar { width: 6px; height: 6px; }
                    .sp-scroll::-webkit-scrollbar-track { background: #f1f5f9; border-radius: 3px; }
                    .sp-scroll::-webkit-scrollbar-thumb { background: #94a3b8 !important; border-radius: 3px; }
                    .sp-scroll::-webkit-scrollbar-thumb:hover { background: #64748b !important; }
                    .sp-tr:hover td { background: #f0f9ff !important; transition: background 0.15s; }
                    .sp-stat-card:hover:not([data-active="true"]) { transform: translateY(-2px) !important; box-shadow: 0 6px 16px rgba(15,23,42,0.12) !important; border-color: var(--card-color) !important; }
                    .sp-stat-card:active { transform: translateY(0px) !important; }
                    section * { font-weight: inherit; }

                    .sp-page-header { width: 100%; box-sizing: border-box; }
                    .sp-page-header-main { display: flex; align-items: center; gap: 12px; min-width: 0; flex: 1 1 320px; }
                    .sp-flow-toggle { flex-shrink: 0; }

                    .sp-action-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 16px; margin-bottom: 16px; margin-top: 100px; }
                    .sp-stat-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(155px, 1fr)); gap: 12px; }
                    .sp-pagination { display: flex; align-items: center; justify-content: space-between; margin-top: 16px; padding-top: 12px; border-top: 1px solid #E2E8F0; }
                    .sp-table-wrap { overflow-x: auto; -webkit-overflow-scrolling: touch; }
                    .sp-section { padding: 16px; }

                    @media (max-width: 640px) {
                        section.sp-root { padding: 8px !important; padding-top: 0 !important; }
                        .sp-page-header { gap: 8px !important; padding: 10px 12px !important; }
                        .sp-page-header-main { justify-content: flex-start !important; flex: 1 !important; }
                        .sp-flow-toggle { width: auto; }
                        .sp-nav-link { font-size: 11px !important; padding: 6px 10px !important; }

                        .sp-action-grid { grid-template-columns: 1fr !important; margin-top: 8px !important; }
                        .sp-stat-grid { grid-template-columns: repeat(2, 1fr) !important; }
                        .sp-stat-card { padding: 12px !important; }
                        .sp-stat-card > div:last-child { display: none; }

                        .sp-pagination { flex-wrap: wrap; gap: 8px; justify-content: center !important; }
                        .sp-section { padding: 10px !important; }

                        .sp-context-bar { flex-direction: column !important; align-items: flex-start !important; }
                        .sp-detail-cards { flex-direction: column !important; }
                    }
                `}</style>
                {/* Page Header */}
                <div style={{
                        position: 'sticky',
                        top: '60px',
                        zIndex: 98,
                        background: '#fff',
                        marginTop: '30px',
                        borderBottom: '1px solid #E3E3E3',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '12px',
                        padding: '12px 24px',
                }} className="sp-page-header">
                    <div>
                        <Link
                            to="/pharmacy-orders"
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '8px',

                                    padding: '10px 18px',
                                    borderRadius: '12px',

                                    background: '#FFFFFF',
                                    color: '#111111',

                                    fontSize: '13px',
                                    fontWeight: '600',
                                    letterSpacing: '0.3px',

                                    textDecoration: 'none',
                                    whiteSpace: 'nowrap',

                                    border: '4px solid #E5E7EB',

                                    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.06)',

                                    cursor: 'pointer',
                                    userSelect: 'none',

                                    transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                                }}
                                onMouseEnter={e => {
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                    e.currentTarget.style.boxShadow = '0 8px 18px rgba(0, 0, 0, 0.1)';
                                    e.currentTarget.style.borderColor = '#D1D5DB';
                                    e.currentTarget.style.background = '#FAFAFA';
                                }}
                                onMouseLeave={e => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.06)';
                                    e.currentTarget.style.borderColor = '#E5E7EB';
                                    e.currentTarget.style.background = '#FFFFFF';
                                }}
                        >
                            ← Pharmacy Orders
                        </Link>
                    </div>
                    <div className="sp-page-header-main" style={{ justifyContent: 'center' }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '10px',
                            background: '#F5F3FF',
                            border: '1px solid #DDD6FE',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: BRAND,
                            fontSize: '18px',
                            fontWeight: '800',
                            flexShrink: 0,
                        }}>
                            [-]
                        </div>
                        <div style={{ minWidth: 0, textAlign: 'center' }}>
                            <div style={{ fontSize: '18px', fontWeight: '800', color: '#0f172a', letterSpacing: '-0.3px', lineHeight: 1.2, wordBreak: 'break-word' }}>
                                Pharmacy Scan And Pay
                            </div>
                            <div style={{ fontSize: '12px', color: C.slate, fontWeight: '600', marginTop: '4px', letterSpacing: '0.2px' }}>
                                Ops Dashboard
                            </div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <button
                            onClick={this.toggleSteps}
                            className="sp-flow-toggle"
                            style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '8px', padding: '9px 16px', background: this.state.isFlowChartOpen ? C.dark : '#F8FAFC', color: this.state.isFlowChartOpen ? '#fff' : '#334155', border: `1px solid ${this.state.isFlowChartOpen ? C.dark : C.border}`, borderRadius: '8px', cursor: 'pointer', fontSize: '12px', fontWeight: '700', userSelect: 'none', whiteSpace: 'nowrap' }}
                        >
                            Process Flow {this.state.isFlowChartOpen ? '▲' : '▼'}
                        </button>
                    </div>
                </div>

                {this.state.isFlowChartOpen && (
                    <div style={{ marginBottom: '16px' }}>
                        <ScanAndPayOpsFlow onClose={() => this.setState({ isFlowChartOpen: false })} />
                    </div>
                )}

                {error && (
                    <div style={{ marginBottom: '16px', padding: '10px 16px', background: '#fef2f2', border: '1px solid #fecaca', borderLeft: `4px solid ${C.red}`, borderRadius: '8px', color: '#b91c1c', fontSize: '13px', fontWeight: '500' }}>
                        {error}
                    </div>
                )}

                {/* Enable + Filters grid */}
                <div className="sp-action-grid" style={{ gap: '16px', marginBottom: '16px', marginTop: '100px' }}>

                {/* Enable Scan and Pay */}
                <div style={{ background: '#fff', border: '1px solid #e0e7ff', borderRadius: '12px', boxShadow: '0 2px 10px rgba(15,23,42,0.06)', overflow: 'hidden' }}>
                    <div style={{ padding: '10px 16px', background: 'linear-gradient(90deg,#1d4ed8,#3b82f6)', display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: 'rgba(255,255,255,0.6)', display: 'inline-block' }} />
                        <span style={{ fontSize: '11px', fontWeight: '700', color: '#fff', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Enable Scan &amp; Pay</span>
                    </div>
                    <div style={{ padding: '16px', display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center' }}>
                        <input
                            type="number"
                            value={enableDigitisationRequestId || ''}
                            onChange={this.handleEnableDigitisationRequestIdChange}
                            placeholder="Enter Digitisation ID"
                            className="form-control"
                            style={{ flex: '1 1 180px', minWidth: 0, borderColor: '#c7d2fe', borderRadius: '8px', fontSize: '13px', height: '38px' }}
                        />
                        <label style={{ display: 'flex', alignItems: 'center', gap: '7px', fontSize: '13px', fontWeight: '600', color: '#1e40af', cursor: 'pointer', whiteSpace: 'nowrap', background: '#eff6ff', border: '1px solid #c7d2fe', borderRadius: '8px', padding: '7px 12px', height: '38px', boxSizing: 'border-box' }}>
                            <input
                                type="checkbox"
                                checked={this.state.isForOps}
                                onChange={(e) => this.setState({ isForOps: e.target.checked })}
                                style={{ width: '15px', height: '15px', cursor: 'pointer', accentColor: C.blue }}
                            />
                            Is For Ops
                        </label>
                        <button onClick={this.handleEnableScanAndPay} style={{ height: '38px', padding: '0 20px', background: 'linear-gradient(90deg,#1d4ed8,#3b82f6)', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '13px', fontWeight: '700', whiteSpace: 'nowrap', boxShadow: '0 2px 6px rgba(59,130,246,0.4)' }}>
                            Enable
                        </button>
                        {scanAndPayEnabledUpdatedMessage && (
                            <span style={{ fontSize: '12px', color: '#15803d', fontWeight: '600', background: '#f0fdf4', border: '1px solid #86efac', borderRadius: '6px', padding: '5px 10px' }}>
                                {scanAndPayEnabledUpdatedMessage}
                            </span>
                        )}
                    </div>
                </div>

                {/* Filters */}
                <div style={{ background: '#fff', border: '1px solid #fde68a', borderRadius: '12px', boxShadow: '0 2px 10px rgba(15,23,42,0.06)', overflow: 'hidden' }}>
                    <div style={{ padding: '10px 16px', background: 'linear-gradient(90deg,#d97706,#f59e0b)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: 'rgba(255,255,255,0.6)', display: 'inline-block' }} />
                            <span style={{ fontSize: '11px', fontWeight: '700', color: '#fff', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Filters</span>
                        </div>
                        <span style={{ fontSize: '11px', color: 'rgba(255,255,255,0.75)', fontWeight: '500' }}>Press Enter to apply</span>
                    </div>
                    <div style={{ padding: '16px', display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
                        {[
                            { label: 'Order ID', type: 'number', value: this.state.filterOrderId, onChange: (e) => this.setState({ filterOrderId: e.target.value }), placeholder: 'Order ID' },
                            { label: 'Phone', type: 'tel', value: filterPhone, onChange: this.handleFilterPhoneChange, placeholder: 'Phone number' },
                            { label: 'Digitisation ID', type: 'number', value: filterDigitisationRequestId, onChange: this.handleFilterDigitisationRequestIdChange, placeholder: 'ID' },
                            { label: 'Sponsor Name', type: 'text', value: this.state.filterSponsorName, onChange: (e) => this.setState({ filterSponsorName: e.target.value }), placeholder: 'e.g. Reliance' },
                            { label: 'From Date', type: 'date', value: this.state.filterFromDate, onChange: (e) => this.setState({ filterFromDate: e.target.value, offset: 0, caseType: null }, this.fetchFilteredData) },
                            { label: 'To Date', type: 'date', value: this.state.filterToDate, onChange: (e) => this.setState({ filterToDate: e.target.value, offset: 0, caseType: null }, this.fetchFilteredData) },
                        ].map(({ label, type, value, onChange, placeholder }) => (
                            <label key={label} style={{ display: 'flex', flexDirection: 'column', gap: '5px', flex: '1 1 150px', minWidth: 0 }}>
                                <span style={{ fontSize: '11px', fontWeight: '700', color: '#92400e', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{label}</span>
                                <input
                                    type={type}
                                    value={value}
                                    onChange={onChange}
                                    onKeyDown={(e) => { if (e.key === 'Enter') this.setState({ offset: 0, caseType: null }, this.fetchFilteredData); }}
                                    placeholder={placeholder}
                                    className="form-control"
                                    style={{ borderColor: '#fde68a', borderRadius: '8px', fontSize: '13px', height: '36px' }}
                                />
                            </label>
                        ))}
                        <label style={{ display: 'flex', flexDirection: 'column', gap: '5px', flex: '1 1 130px', minWidth: 0 }}>
                            <span style={{ fontSize: '11px', fontWeight: '700', color: '#92400e', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Enabled By Ops</span>
                            <select
                                value={this.state.filterEnabledByOps}
                                onChange={(e) => this.setState({ filterEnabledByOps: e.target.value, offset: 0, caseType: null }, this.fetchFilteredData)}
                                className="form-control"
                                style={{ borderColor: '#fde68a', borderRadius: '8px', fontSize: '13px', height: '36px' }}
                            >
                                <option value="">All</option>
                                <option value="1">Yes</option>
                                <option value="0">No</option>
                            </select>
                        </label>
                        <label style={{ display: 'flex', flexDirection: 'column', gap: '5px', flex: '1 1 130px', minWidth: 0 }}>
                            <span style={{ fontSize: '11px', fontWeight: '700', color: '#92400e', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Call Status</span>
                            <select
                                value={this.state.filterCallStatus}
                                onChange={(e) => this.setState({ filterCallStatus: e.target.value, offset: 0, caseType: null }, this.fetchFilteredData)}
                                className="form-control"
                                style={{ borderColor: '#fde68a', borderRadius: '8px', fontSize: '13px', height: '36px' }}
                            >
                                <option value="">All</option>
                                <option value="ANSWERED">Answered</option>
                                <option value="MISSED">Missed</option>
                                <option value="INITIATED">In Progress</option>
                                <option value="NOT_TRIGGERED">Not Triggered</option>
                                <option value="NONE">No Call</option>
                            </select>
                        </label>
                    </div>
                </div>

                {/* User Steps */}
                <div style={{ background: '#fff', border: '1px solid #ddd6fe', borderRadius: '12px', boxShadow: '0 2px 10px rgba(108,93,211,0.08)', overflow: 'hidden' }}>
                    <div style={{ padding: '10px 16px', background: `linear-gradient(90deg,${BRAND},#8b5cf6)`, display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: 'rgba(255,255,255,0.6)', display: 'inline-block' }} />
                        <span style={{ fontSize: '11px', fontWeight: '700', color: '#fff', textTransform: 'uppercase', letterSpacing: '0.8px' }}>User Steps</span>
                    </div>
                    <div style={{ padding: '16px', display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center' }}>
                        <input
                            type="number"
                            value={userFlowDigitisationId}
                            onChange={e => this.setState({ userFlowDigitisationId: e.target.value })}
                            onKeyDown={e => { if (e.key === 'Enter' && userFlowDigitisationId) this.openUserFlowModal(); }}
                            placeholder="Enter Digitisation Request ID"
                            className="form-control"
                            style={{ flex: '1 1 200px', minWidth: 0, borderColor: '#ddd6fe', borderRadius: '8px', fontSize: '13px', height: '38px' }}
                        />
                        <button
                            onClick={() => this.openUserFlowModal()}
                            style={{ height: '38px', padding: '0 20px', background: `linear-gradient(90deg,${BRAND},#8b5cf6)`, color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '13px', fontWeight: '700', whiteSpace: 'nowrap', boxShadow: '0 2px 6px rgba(108,93,211,0.4)' }}
                        >
                            Next Step →
                        </button>
                    </div>
                </div>

                </div>{/* end Enable+Filters grid */}

                {/* Summary Stat Cards */}
                <div style={{ marginBottom: '16px' }}>
                    {caseListSummaryLoading ? (
                        <div style={{ textAlign: 'center', padding: '20px' }}><Spinner /></div>
                    ) : (
                        <div className="sp-stat-grid" style={{ gap: '12px' }}>
                            {[
                                { label: 'Total Cases',          value: caseListSummary?.totalCaseCount,           type: null,                   color: '#1d4ed8', border: '#bfdbfe', bar: '#3b82f6', grad: 'linear-gradient(135deg,#eff6ff,#dbeafe)' },
                                { label: 'Completed',            value: caseListSummary?.completedCaseCount,       type: 'completed',            color: '#15803d', border: '#86efac', bar: '#22c55e', grad: 'linear-gradient(135deg,#f0fdf4,#dcfce7)' },
                                { label: 'Payout Stuck',         value: caseListSummary?.storePaymentStuckCount,   type: 'store-payout-stuck',   color: '#b91c1c', border: '#fca5a5', bar: '#ef4444', grad: 'linear-gradient(135deg,#fff5f5,#fee2e2)' },
                                { label: 'Invoice Not Uploaded', value: caseListSummary?.invoiceNotUploadedCount,  type: 'invoice-not-uploaded', color: '#c2410c', border: '#fdba74', bar: '#f97316', grad: 'linear-gradient(135deg,#fff7ed,#ffedd5)' },
                                { label: 'Not Inspected',        value: caseListSummary?.invoiceNotInspectedCount, type: 'invoice-not-inspected',color: '#6d28d9', border: '#c4b5fd', bar: '#8b5cf6', grad: 'linear-gradient(135deg,#faf5ff,#ede9fe)' },
                                { label: 'Not Closed',           value: caseListSummary?.invoiceNotClosed,         type: 'invoice-not-closed',   color: '#9d174d', border: '#f9a8d4', bar: '#ec4899', grad: 'linear-gradient(135deg,#fdf2f8,#fce7f3)' },
                            ].map(({ label, value, type, color, border, bar, grad }) => {
                                const isActive = this.state.caseType === type;
                                return (
                                    <button
                                        key={type}
                                        onClick={() => this.setState({ offset: 0, caseType: type }, this.getCaseList)}
                                        className="sp-stat-card"
                                        data-active={isActive}
                                        style={{
                                            '--card-color': color,
                                            '--card-border': border,
                                            '--card-bar': bar,
                                            background: isActive ? `linear-gradient(135deg, ${color}, ${bar})` : grad,
                                            border: `1.5px solid ${isActive ? color : border}`,
                                            borderRadius: '12px',
                                            padding: '16px',
                                            cursor: 'pointer',
                                            boxShadow: isActive ? `0 6px 20px ${border}` : '0 1px 3px rgba(15,23,42,0.07)',
                                            transition: 'all 0.18s ease',
                                            textAlign: 'left',
                                            width: '100%',
                                            outline: 'none',
                                            transform: isActive ? 'translateY(-3px)' : 'none',
                                            position: 'relative',
                                            overflow: 'hidden',
                                        }}
                                    >
                                        {/* top accent bar */}
                                        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '3px', background: isActive ? 'rgba(255,255,255,0.4)' : bar, borderRadius: '12px 12px 0 0' }} />

                                        {/* active badge */}
                                        {isActive && (
                                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '6px' }}>
                                                <span style={{ fontSize: '10px', fontWeight: '700', background: 'rgba(255,255,255,0.25)', color: '#fff', padding: '2px 7px', borderRadius: '20px', letterSpacing: '0.4px' }}>
                                                    ACTIVE
                                                </span>
                                            </div>
                                        )}

                                        {/* count */}
                                        <div style={{ fontSize: '32px', fontWeight: '800', color: isActive ? '#fff' : color, lineHeight: 1, marginBottom: '6px' }}>
                                            {value ?? 0}
                                        </div>

                                        {/* label */}
                                        <div style={{ fontSize: '11px', fontWeight: '600', color: isActive ? 'rgba(255,255,255,0.85)' : color, textTransform: 'uppercase', letterSpacing: '0.5px', lineHeight: 1.3 }}>
                                            {label}
                                        </div>

                                        {/* bottom hint */}
                                        <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center', gap: '4px', fontSize: '11px', color: isActive ? 'rgba(255,255,255,0.65)' : '#94a3b8', fontWeight: '500' }}>
                                            <span style={{ width: '14px', height: '14px', borderRadius: '50%', border: `1.5px solid ${isActive ? 'rgba(255,255,255,0.5)' : border}`, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: '9px', color: isActive ? 'rgba(255,255,255,0.7)' : color }}>
                                                {isActive ? '✓' : '›'}
                                            </span>
                                            {isActive ? 'Filtered' : 'Filter by this'}
                                        </div>
                                    </button>
                                );
                            })}
                        </div>
                    )}
                </div>


                {/* Case List Section */}
                <div className="call-list" style={{ marginBottom: '16px' }}>
                    {caseListLoading ? (
                        <div style={{ textAlign: 'center', padding: '20px' }}>
                            <Spinner />
                        </div>
                    ) : (
                        <div style={sectionCardStyle}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '0 0 12px' }}>
                                <h6 style={{ margin: 0, padding: '8px 12px', borderLeft: `4px solid ${C.blue}`, background: '#f8fafc', borderRadius: '0 6px 6px 0', color: '#0f172a', fontWeight: '700', fontSize: '13px', letterSpacing: '0.2px', userSelect: 'none' }}>
                                    Scan And Pay Cases {caseList.length > 0 && <span style={{ marginLeft: '8px', background: C.blue, color: '#fff', borderRadius: '10px', padding: '1px 8px', fontSize: '11px' }}>{caseList.length}</span>}
                                </h6>
                                {caseList.length > 0 && (
                                    <button onClick={this.downloadCsv} disabled={csvDownloading} style={{ padding: '6px 14px', background: csvDownloading ? '#86efac' : '#22C55E', color: '#fff', border: 'none', borderRadius: '4px', cursor: csvDownloading ? 'not-allowed' : 'pointer', fontSize: '12px', fontWeight: '600' }}>
                                        {csvDownloading ? 'Downloading...' : '⬇ Download CSV'}
                                    </button>
                                )}
                            </div>

                            {caseList.length === 0 ? (
                                <div style={{ padding: '24px', textAlign: 'center', color: '#94a3b8', fontSize: '13px' }}>No cases found</div>
                            ) : (
                                <div className="sp-scroll sp-table-wrap">
                                    <table style={{ width: '100%', minWidth: '1400px', borderCollapse: 'collapse', fontSize: '13px' }}>
                                        <thead>
                                            <tr style={{ background: '#f1f5f9', userSelect: 'none', borderBottom: `2px solid ${C.blue}` }}>
                                                {[
                                                    'Cart ID', 'Digitisation ID', 'Sponsor Name', 'Enabled By Ops Email', 'Enabled At', 'User Name', 'User Phone',
                                                    'VIP User', 'Call Requested', 'Call Status', 'Payout Attempted', 'Payout Closed',
                                                    'Invoice Uploaded', 'Reimbursement ID', 'Invoice Inspected',
                                                    'Invoice Approved', 'Invoice Rejected',
                                                    'Payout Amount', 'Invoice Approved Amount', 'Outstanding Amount', 'Invoice Closed',
                                                ].map((h, i) => (
                                                    <th key={i} style={{ padding: '11px 14px', color: C.slate, fontWeight: '700', whiteSpace: 'nowrap', borderRight: `1px solid ${C.border}`, textAlign: 'left', fontSize: '11px', letterSpacing: '0.5px', textTransform: 'uppercase' }}>{h}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {caseList.map((call, index) => {
                                                const isActive = this.state.cartId === call.cartId && this.state.selectedRowIndex === index;
                                                const bg = isActive ? '#eff6ff' : index % 2 === 0 ? '#fff' : '#f8fafc';
                                                return (
                                                    <tr key={index} className="sp-tr" style={{ background: bg, borderBottom: `1px solid ${C.border}`, borderLeft: isActive ? `3px solid ${C.blue}` : '3px solid transparent', cursor: 'pointer' }}
                                                        onClick={() => {
                                                            const contextData = {
                                                                digitisationRequestId: call.digitisationRequestId || '',
                                                                userName: call.userName || '',
                                                                userPhone: call.userPhone || ''
                                                            };
                                                            localStorage.setItem(`scan-and-pay-cart-${call.cartId}`, JSON.stringify(contextData));
                                                            window.open(`/pharmacy-scan-and-pay-cart-details/${call.cartId}`, '_blank');
                                                        }}
                                                    >
                                                        <td style={{ padding: '10px 14px', whiteSpace: 'nowrap', color: C.blue, fontWeight: '700', fontSize: '13px' }}>{call.cartId}</td>
                                                        <td style={{ padding: '10px 14px', whiteSpace: 'nowrap', color: '#334155' }}>{call.digitisationRequestId}</td>
                                                        <td style={{ padding: '10px 14px', whiteSpace: 'nowrap', color: '#334155' }}>{call.sponsorName || '—'}</td>
                                                        <td style={{ padding: '10px 14px', whiteSpace: 'nowrap', color: '#334155' }}>{call.enabledByOpsUserEmail || '—'}</td>
                                                        <td style={{ padding: '10px 14px', whiteSpace: 'nowrap', color: '#334155' }}>{call.enabledAt || '—'}</td>
                                                        <td style={{ padding: '10px 14px', whiteSpace: 'nowrap', color: '#334155' }}>{call.userName}</td>
                                                        <td style={{ padding: '10px 14px', whiteSpace: 'nowrap', color: '#334155' }}>{call.userPhone}</td>
                                                        <td style={{ padding: '10px 14px', textAlign: 'center' }}>{call.isVipUser ? <span style={{ color: C.green, fontWeight: '700' }}>✓</span> : <span style={{ color: '#94a3b8' }}>—</span>}</td>
                                                        <td style={{ padding: '10px 14px', textAlign: 'center' }}>{call.isCallRequested ? <span style={{ color: C.green, fontWeight: '700' }}>✓</span> : <span style={{ color: '#94a3b8' }}>—</span>}</td>
                                                        <td style={{ padding: '10px 14px', whiteSpace: 'nowrap' }}>{statusBadge(call.callStatus)}</td>
                                                        <td style={{ padding: '10px 14px', textAlign: 'center' }}>{call.isPayoutAttempted ? <span style={{ color: C.green, fontWeight: '700' }}>✓</span> : <span style={{ color: '#94a3b8' }}>—</span>}</td>
                                                        <td style={{ padding: '10px 14px', textAlign: 'center' }}>{call.isPayoutClosed ? <span style={{ color: C.green, fontWeight: '700' }}>✓</span> : <span style={{ color: '#94a3b8' }}>—</span>}</td>
                                                        <td style={{ padding: '10px 14px', textAlign: 'center' }}>{call.isInvoiceUploaded ? <span style={{ color: C.green, fontWeight: '700' }}>✓</span> : <span style={{ color: '#94a3b8' }}>—</span>}</td>
                                                        <td style={{ padding: '10px 14px', whiteSpace: 'nowrap', color: '#334155' }}>{call.reimbursementRequestId || '—'}</td>
                                                        <td style={{ padding: '10px 14px', textAlign: 'center' }}>{call.isInvoiceInspected ? <span style={{ color: C.green, fontWeight: '700' }}>✓</span> : <span style={{ color: '#94a3b8' }}>—</span>}</td>
                                                        <td style={{ padding: '10px 14px', textAlign: 'center' }}>{call.isInvoiceApproved ? <span style={{ color: C.green, fontWeight: '700' }}>✓</span> : <span style={{ color: '#94a3b8' }}>—</span>}</td>
                                                        <td style={{ padding: '10px 14px', textAlign: 'center' }}>{call.isInvoiceRejected ? <span style={{ color: C.green, fontWeight: '700' }}>✓</span> : <span style={{ color: '#94a3b8' }}>—</span>}</td>
                                                        <td style={{ padding: '10px 14px', whiteSpace: 'nowrap', color: C.green, fontWeight: '600' }}>{call.payoutAmount ? `₹${call.payoutAmount}` : '—'}</td>
                                                        <td style={{ padding: '10px 14px', whiteSpace: 'nowrap', color: C.blue, fontWeight: '600' }}>{call.invoiceApprovedAmount ? `₹${call.invoiceApprovedAmount}` : '—'}</td>
                                                        <td style={{ padding: '10px 14px', whiteSpace: 'nowrap', color: C.amber, fontWeight: '600' }}>{call.outStandingAmount ? `₹${call.outStandingAmount}` : '—'}</td>
                                                        <td style={{ padding: '10px 14px', textAlign: 'center' }}>{call.isInvoiceClosed ? <span style={{ color: C.green, fontWeight: '700' }}>✓</span> : <span style={{ color: '#94a3b8' }}>—</span>}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            )}

                            {/* Pagination */}
                            <div className="sp-pagination" style={{ marginTop: '16px', paddingTop: '12px', borderTop: `1px solid ${C.border}` }}>
                                <span style={{ fontSize: '12px', color: C.slate, fontWeight: '500' }}>
                                    Total <strong>{totalCount}</strong> case{totalCount !== 1 ? 's' : ''}
                                </span>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
                                    <button
                                        onClick={this.handlePrevPage}
                                        disabled={offset <= 0}
                                        style={{
                                            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                            padding: '4px 10px', fontSize: '13px', fontWeight: '500',
                                            background: offset <= 0 ? '#f8fafc' : '#fff',
                                            color: offset <= 0 ? '#94a3b8' : '#0f172a',
                                            border: `1px solid ${offset <= 0 ? C.border : '#cbd5e1'}`,
                                            borderRadius: '6px', cursor: offset <= 0 ? 'not-allowed' : 'pointer',
                                            minHeight: '32px'
                                        }}
                                    >
                                        ‹ Prev
                                    </button>
                                    
                                    {(()=>{
                                        const activePage = Math.floor(offset) + 1;
                                        const getPageNums = () => {
                                            const total = totalPages;
                                            if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
                                            const cur = activePage;
                                            const nums = new Set([1, total]);
                                            for (let i = Math.max(1, cur - 1); i <= Math.min(total, cur + 1); i++) nums.add(i);
                                            return Array.from(nums).sort((a, b) => a - b);
                                        };
                                        const pageNums = getPageNums();
                                        
                                        return pageNums.map((p, i) => {
                                            const prev = pageNums[i - 1];
                                            const showEllipsis = prev !== undefined && p - prev > 1;
                                            const isActive = p === activePage;
                                            
                                            return (
                                                <React.Fragment key={p}>
                                                    {showEllipsis && (
                                                        <span style={{ color: C.slate, padding: '0 4px' }}>...</span>
                                                    )}
                                                    <button
                                                        onClick={() => {
                                                            this.setState({ offset: p - 1 }, this.getCaseList);
                                                        }}
                                                        style={{
                                                            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                                            minWidth: '32px', minHeight: '32px', padding: '4px 8px',
                                                            fontSize: '13px', fontWeight: isActive ? '700' : '500',
                                                            background: isActive ? C.blue : '#fff',
                                                            color: isActive ? '#fff' : '#0f172a',
                                                            border: `1px solid ${isActive ? C.blue : '#cbd5e1'}`,
                                                            borderRadius: '6px', cursor: 'pointer',
                                                        }}
                                                    >
                                                        {p}
                                                    </button>
                                                </React.Fragment>
                                            );
                                        });
                                    })()}

                                    <button
                                        onClick={this.handleNextPage}
                                        disabled={offset + 1 >= totalPages}
                                        style={{
                                            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                            padding: '4px 10px', fontSize: '13px', fontWeight: '500',
                                            background: offset + 1 >= totalPages ? '#f8fafc' : '#fff', 
                                            color: offset + 1 >= totalPages ? '#94a3b8' : '#0f172a',
                                            border: `1px solid ${offset + 1 >= totalPages ? C.border : '#cbd5e1'}`,
                                            borderRadius: '6px', cursor: offset + 1 >= totalPages ? 'not-allowed' : 'pointer',
                                            minHeight: '32px'
                                        }}
                                    >
                                        Next ›
                                    </button>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', color: '#64748b' }}>
                                    <span>Go to</span>
                                    <input 
                                        type="number" 
                                        min="1" 
                                        max={totalPages}
                                        defaultValue={Math.floor(offset) + 1}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                let val = parseInt(e.target.value, 10);
                                                if (!isNaN(val)) {
                                                    val = Math.max(1, Math.min(val, totalPages));
                                                    e.target.value = val;
                                                    this.setState({ offset: val - 1 }, this.getCaseList);
                                                }
                                            }
                                        }}
                                        onBlur={(e) => {
                                            let val = parseInt(e.target.value, 10);
                                            if (!isNaN(val)) {
                                                val = Math.max(1, Math.min(val, totalPages));
                                                e.target.value = val;
                                                this.setState({ offset: val - 1 }, this.getCaseList);
                                            }
                                        }}
                                        style={{
                                            width: '50px', height: '32px', textAlign: 'center',
                                            border: `1px solid ${C.border}`, borderRadius: '6px',
                                            outline: 'none', color: '#0f172a', fontWeight: '500'
                                        }}
                                    />
                                    <span>of <strong>{totalPages}</strong> pages</span>
                                </div>
                            </div>

                            <div style={{ marginTop: '16px' }}>
                                {/* The inline cart details view has been moved to PharmacyScanAndPayCartDetails.js */}
                            </div>
                        </div>
                    )}
                </div>

                {this.state.userFlowModal && (
                    <ScanAndPayUserFlowModal
                        cartId={this.state.userFlowModal.cartId}
                        digitisationRequestId={this.state.userFlowModal.digitisationRequestId}
                        storeId={this.state.userFlowModal.storeId}
                        storeName={this.state.userFlowModal.storeName}
                        storeAddress={this.state.userFlowModal.storeAddress}
                        storePincode={this.state.userFlowModal.storePincode}
                        storeLatitude={this.state.userFlowModal.storeLatitude}
                        storeLongitude={this.state.userFlowModal.storeLongitude}
                        storeState={this.state.userFlowModal.storeState}
                        storeCity={this.state.userFlowModal.storeCity}
                        onClose={() => this.setState({ userFlowModal: null })}
                    />
                )}

                <ModalConfirm
                    message={callConfirmModal.message}
                    onConfirm={callConfirmModal.onConfirm}
                    onClose={callConfirmModal.onClose}
                    isOpen={callConfirmModal.isOpen}
                    isOpsCallForPharmacy={callConfirmModal.isOpsCallForPharmacy}
                    opsCallReasons={callConfirmModal.opsCallReasons}
                />
            </section>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    authToken: state.user.authToken,
    user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
    closeSidebar: () => dispatch(toggleSidebar(false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PharmacyScanAndPayHome);
